/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const CardGrid = ({ className, items, columns }) => {
    const classes = classnames('card-grid', className);

    const styles = {
        display: 'grid',
        gridTemplateColumns: 'repeat(' + columns + ', 1fr)',
        'grid-auto-rows': 'auto',
        'grid-gap': '1rem',
    };

    return (
        <Box className={classes} style={styles}>
            {map(items, ({ renderer, key, onClick, ...item }) => (
                <Box
                    component={onClick ? 'button' : 'div'}
                    onClick={onClick && (() => onClick(item))}
                    className='card-grid__item'
                    key={key}
                    type={onClick ? 'button' : 'div'}
                >
                    {renderer && renderer(item)}
                </Box>
            ))}
        </Box>
    );
};

CardGrid.defaultProps = {
    columns: 3,
};
export default CardGrid;
